<template>
    <v-dialog :value="value" max-width="500" persistent @input="$emit('input', $event)">
        <v-card>
            <v-card-title class="font-weight-bold">
                Recuperar Senha
            </v-card-title>
            <v-card-text>
                <p class="mb-6">
                    Insira o seu e-mail para iniciar a recuperação de senha.
                </p>
                <v-form ref="form">
                    <v-text-field
                        v-model="email"
                        label="E-mail"
                        type="email"
                        outlined
                        dense
                        hide-details="auto"
                        :rules="[rules.required, rules.email]"
                    />
                </v-form>
            </v-card-text>
            <v-card-actions class="justify-end px-6 pb-4">
                <v-btn text color="grey" @click="close">
                    Cancelar
                </v-btn>
                <v-btn color="primary" elevation="0" :loading="loading" @click="submit">
                    Enviar
                </v-btn>
            </v-card-actions>
        </v-card>

        <reset-password-with-code v-model="showReset" :email="email" />
    </v-dialog>
</template>

<script>
import axios from 'axios';
import ResetPasswordWithCode from './ResetPasswordWithCode.vue';

export default {
    name: 'ForgotPassword',

    components: {
        ResetPasswordWithCode,
    },

    props: {
        value: { type: Boolean, default: false },
    },

    data: () => ({
        loading: false,
        email: '',
        showReset: false,
        rules: {
            required: v => !!v || 'Campo obrigatório.',
            email: v => /.+@.+\..+/.test(v) || 'E-mail inválido.',
        },
    }),

    methods: {
        close() {
            this.email = '';
            this.$refs.form && this.$refs.form.resetValidation();
            this.$emit('input', false);
        },

        async submit() {
            if (!this.$refs.form.validate()) return;

            this.loading = true;

            try {
                await axios.post('/api/admin/client/forgot-password', {
                    email: this.email,
                });

                this.$emit('input', false);
                this.showReset = true;
            } catch (error) {
                const msg = error.response && error.response.data && error.response.data.content
                    ? error.response.data.content.error.message
                    : 'Erro ao solicitar recuperação de senha';
                this.$dialog.notify.error(msg, { position: 'top-right', timeout: 5000 });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
